import { StyledText } from './text.styled';

export default StyledText;
